import React from "react";
import {
  PDFDownloadLink,
} from "@react-pdf/renderer";
import styled from "styled-components";
import MoonLoader from "react-spinners/MoonLoader";
import { EstiloButton } from "./App";
import { BotonGenerarPDF } from "./FirestoreTableContrato";
import PresupuestoPDFDocument from "./PresupuestoPDFDocument";

const ContenedorLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
const SpinnerContainerLoading = styled.div`
  width: auto;
  display: flex;
  margin-top: 10px;
`;
const SpinnerTexto = styled.div`
  font-weight: bold;
`;
const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
  color: gray;
`;

const PresupuestoPDF = ({ datos, pdfVisible }) => {
  /// Lógica para generar el nombre del archivo PDF
  const nombreArchivo = datos.empresa
    ? `Presupuesto ${datos.empresa}.pdf`
    : "presupuesto.pdf";

  return (
    <div>
      <StyledPDFDownloadLink
        document={<PresupuestoPDFDocument datos={datos} />}
        fileName={nombreArchivo}
      >
        {({ loading }) => (
          <ContenedorLoading>
            {loading ? (
              <>
                <SpinnerContainerLoading>
                  <MoonLoader color="#c20000" size={pdfVisible ? 20 : 50} />
                </SpinnerContainerLoading>
                {!pdfVisible && <SpinnerTexto>Generando PDF...</SpinnerTexto>}
              </>
            ) : pdfVisible ? (
              <BotonGenerarPDF>Descargar</BotonGenerarPDF>
            ) : (
              <EstiloButton>Descargar Presupuesto</EstiloButton>
            )}
          </ContenedorLoading>
        )}
      </StyledPDFDownloadLink>
    </div>
  );
};

export default PresupuestoPDF;
